import { create } from 'zustand/react';

export type ConfirmModalMode = 'cancel' | 'removePlanner' | 'delete';
export const CONFIRM_MODAL_MODES: ConfirmModalMode[] = [
    'cancel',
    'removePlanner',
    'delete',
];

interface TodoModalStore {
    isModalOpen: boolean;
    modalMode: ConfirmModalMode | null;
    canRemovePlanner: boolean;
    targetDate: string | null;

    actions: {
        handleCancelTodo: (() => Promise<void>) | null;
        handleRemovePlanner: (() => Promise<void>) | null;
        handleDeleteTodo: (() => Promise<void>) | null;
    };

    changeModalMode: (modalMode: ConfirmModalMode) => void;

    openModal: ({
        modalMode,
        targetDate,
        canRemovePlanner,
        handleCancelTodo,
        handleRemovePlanner,
        handleDeleteTodo,
    }: {
        modalMode: ConfirmModalMode;
        targetDate: string | null;
        canRemovePlanner: boolean;
        handleCancelTodo: (() => Promise<void>) | null;
        handleRemovePlanner: (() => Promise<void>) | null;
        handleDeleteTodo: (() => Promise<void>) | null;
    }) => void;
    closeModal: () => void;
}

export const useTodoModalStore = create<TodoModalStore>(set => ({
    isModalOpen: false,
    modalMode: null,
    canRemovePlanner: false,
    targetDate: null,

    actions: {
        handleCancelTodo: null,
        handleRemovePlanner: null,
        handleDeleteTodo: null,
    },

    changeModalMode: (modalMode: ConfirmModalMode) => {
        set({
            modalMode,
        });
    },

    openModal: ({
        modalMode,
        targetDate,
        canRemovePlanner,
        handleCancelTodo,
        handleRemovePlanner,
        handleDeleteTodo,
    }) => {
        set({
            isModalOpen: true,
            modalMode,
            targetDate,
            canRemovePlanner,
            actions: {
                handleCancelTodo,
                handleRemovePlanner,
                handleDeleteTodo,
            },
        });
    },

    closeModal: () => {
        set({
            isModalOpen: false,
            modalMode: null,
            canRemovePlanner: false,
            targetDate: null,
            actions: {
                handleCancelTodo: null,
                handleRemovePlanner: null,
                handleDeleteTodo: null,
            },
        });
    },
}));
